import React, { useState, useEffect } from 'react';
import axios from 'axios';

const fmt = (n) => n ? Number(n).toLocaleString('tr-TR') : '0';
const yuzde = (n) => (n || 0) + '%';

const StatKart = ({ baslik, deger, alt, renk, ikon }) => (
  <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', padding: '1.25rem', display: 'flex', flexDirection: 'column', gap: '6px' }}>
    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
      <span style={{ fontSize: '13px', color: '#6B7280', fontWeight: '500' }}>{baslik}</span>
      {ikon && <span style={{ fontSize: '20px' }}>{ikon}</span>}
    </div>
    <div style={{ fontSize: '26px', fontWeight: '700', color: renk || '#111827' }}>{deger}</div>
    {alt && <div style={{ fontSize: '12px', color: '#9CA3AF' }}>{alt}</div>}
  </div>
);

const Bolum = ({ baslik, children }) => (
  <div style={{ marginBottom: '2rem' }}>
    <div style={{ fontSize: '13px', fontWeight: '600', color: '#6B7280', textTransform: 'uppercase', letterSpacing: '0.06em', marginBottom: '1rem', paddingBottom: '6px', borderBottom: '1px solid #F3F4F6' }}>
      {baslik}
    </div>
    {children}
  </div>
);

const ProgressBar = ({ deger, renk, max = 100 }) => (
  <div style={{ background: '#F3F4F6', borderRadius: '99px', height: '8px', overflow: 'hidden' }}>
    <div style={{ width: Math.min(100, max > 0 ? (deger / max) * 100 : 0) + '%', height: '100%', background: renk || '#1a56db', borderRadius: '99px', transition: 'width 0.5s' }} />
  </div>
);

const MusteriNetKarChart = ({ veriler }) => {
  const [tooltip, setTooltip] = useState(null);
  const maxAbsKar = Math.max(...veriler.map(m => Math.abs(m.net_kar)), 1);
  const chartHeight = 200;
  const barWidth = Math.max(20, Math.min(60, Math.floor(600 / veriler.length) - 8));
  const gap = Math.max(4, Math.min(12, Math.floor(200 / veriler.length)));

  return (
    <div style={{ position: 'relative' }}>
      {/* Y ekseni çizgileri */}
      <div style={{ display: 'flex', gap: String(gap) + 'px', alignItems: 'flex-end', overflowX: 'auto', padding: '1rem 1.25rem 0.5rem', minHeight: String(chartHeight + 60) + 'px' }}>
        {veriler.map((m, i) => {
          const karOrani = m.gelir > 0 ? Math.round((m.net_kar / m.gelir) * 100) : 0;
          const barH = Math.round((Math.abs(m.net_kar) / maxAbsKar) * chartHeight);
          const pozitif = m.net_kar >= 0;
          const renk = pozitif ? '#059669' : '#DC2626';
          const acikRenk = pozitif ? '#D1FAE5' : '#FEE2E2';

          return (
            <div key={i} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '4px', flexShrink: 0, width: String(barWidth) + 'px' }}
              onMouseEnter={() => setTooltip(i)}
              onMouseLeave={() => setTooltip(null)}>

              {/* Değer etiketi */}
              <div style={{ fontSize: '10px', fontWeight: '700', color: renk, textAlign: 'center', minHeight: '14px' }}>
                {m.net_kar >= 0 ? '+' : ''}{Math.round(m.net_kar / 1000)}K
              </div>

              {/* Bar */}
              <div style={{ width: '100%', height: String(barH || 4) + 'px', background: renk, borderRadius: '4px 4px 0 0', transition: 'height 0.5s', position: 'relative', cursor: 'pointer' }}>
                {tooltip === i && (
                  <div style={{
                    position: 'absolute', bottom: '100%', left: '50%', transform: 'translateX(-50%)',
                    background: '#1F2937', color: '#fff', padding: '8px 12px', borderRadius: '8px',
                    fontSize: '12px', whiteSpace: 'nowrap', zIndex: 10, marginBottom: '6px',
                    boxShadow: '0 4px 12px rgba(0,0,0,0.2)'
                  }}>
                    <div style={{ fontWeight: '700', marginBottom: '4px' }}>{m.firma_adi}</div>
                    <div>Gelir: {fmt(m.gelir)} TL</div>
                    <div>Maliyet: {fmt(m.maliyet)} TL</div>
                    <div style={{ color: pozitif ? '#34D399' : '#F87171', fontWeight: '700' }}>
                      Net Kar: {m.net_kar >= 0 ? '+' : ''}{fmt(m.net_kar)} TL
                    </div>
                    <div style={{ color: '#9CA3AF' }}>Kar Marji: {karOrani}%</div>
                    <div style={{ position: 'absolute', top: '100%', left: '50%', transform: 'translateX(-50%)', width: 0, height: 0, borderLeft: '5px solid transparent', borderRight: '5px solid transparent', borderTop: '5px solid #1F2937' }} />
                  </div>
                )}
              </div>

              {/* Müşteri adı */}
              <div style={{
                fontSize: '10px', color: '#6B7280', textAlign: 'center',
                writingMode: veriler.length > 10 ? 'vertical-rl' : 'horizontal-tb',
                transform: veriler.length > 10 ? 'rotate(180deg)' : 'none',
                maxHeight: veriler.length > 10 ? '80px' : 'none',
                overflow: 'hidden', width: '100%',
              }}>
                {m.firma_adi.length > 12 ? m.firma_adi.slice(0, 12) + '…' : m.firma_adi}
              </div>
            </div>
          );
        })}
      </div>

      {/* 0 çizgisi */}
      <div style={{ margin: '0 1.25rem', borderTop: '2px solid #E5E7EB' }} />

      {/* Legend */}
      <div style={{ display: 'flex', gap: '16px', padding: '8px 1.25rem', fontSize: '12px', color: '#6B7280' }}>
        <span><span style={{ display: 'inline-block', width: '10px', height: '10px', background: '#059669', borderRadius: '2px', marginRight: '4px' }} />Kar</span>
        <span><span style={{ display: 'inline-block', width: '10px', height: '10px', background: '#DC2626', borderRadius: '2px', marginRight: '4px' }} />Zarar</span>
        <span style={{ marginLeft: 'auto' }}>Uzerine gelin detay icin</span>
      </div>
    </div>
  );
};

const YonetimDashboardPage = () => {
  const [veri, setVeri] = useState(null);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState(null);

  const yukle = () => {
    setYukleniyor(true);
    axios.get('/api/dashboard')
      .then(r => { setVeri(r.data); setYukleniyor(false); })
      .catch(err => { setHata(err.response?.data?.hata || 'Veri yuklenemedi.'); setYukleniyor(false); });
  };

  useEffect(() => { yukle(); }, []);

  if (yukleniyor) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '400px', color: '#6B7280' }}>
      Yukleniyor...
    </div>
  );

  if (hata) return <div style={{ padding: '2rem', color: '#DC2626' }}>{hata}</div>;

  const { finansal, personel, isealim, turnover, risk, egitim, operasyonel } = veri;

  const netKarPerPersonel = personel.outsource > 0
    ? Math.round(finansal.kar / personel.outsource)
    : 0;

  const musteriNetKarlar = (finansal.musteri_gelir || []).map(m => ({
    ...m,
    net_kar: (m.gelir || 0) - (m.maliyet || 0)
  })).sort((a, b) => b.net_kar - a.net_kar);

  return (
    <div>
      <div style={{ marginBottom: '2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: '1rem' }}>
        <div>
          <h2 style={{ fontSize: '22px', fontWeight: '700', marginBottom: '4px' }}>Yonetim Paneli</h2>
          <p style={{ fontSize: '13px', color: '#6B7280' }}>Genel performans ve operasyonel metrikler</p>
        </div>
        <button onClick={yukle} style={{ padding: '8px 16px', border: '1px solid #E5E7EB', borderRadius: '8px', background: '#fff', cursor: 'pointer', fontSize: '13px', fontWeight: '500' }}>
          Yenile
        </button>
      </div>

      {/* FİNANSAL */}
      <Bolum baslik="Finansal Ozet">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
          <StatKart baslik="Toplam Gelir" deger={fmt(finansal.toplam_gelir) + ' TL'} ikon="💰" renk="#059669" />
          <StatKart baslik="Toplam Maliyet" deger={fmt(finansal.toplam_maliyet) + ' TL'} ikon="📉" renk="#DC2626" />
          <StatKart baslik="Net Kar" deger={fmt(finansal.kar) + ' TL'} ikon="📈" renk={finansal.kar >= 0 ? '#059669' : '#DC2626'} />
          <StatKart baslik="Kar Marji" deger={yuzde(finansal.kar_marji)} ikon="%" renk={finansal.kar_marji >= 20 ? '#059669' : '#F59E0B'} />
        </div>

        {musteriNetKarlar.length > 0 && (
          <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', overflow: 'hidden' }}>
            <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid #F3F4F6', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span style={{ fontSize: '14px', fontWeight: '600' }}>Musteri Bazli Net Kar</span>
              <span style={{ fontSize: '12px', color: '#6B7280' }}>{musteriNetKarlar.length} musteri</span>
            </div>
            <MusteriNetKarChart veriler={musteriNetKarlar} />
          </div>
        )}
      </Bolum>

      {/* PERSONEL */}
      <Bolum baslik="Outsource Personel">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
          <StatKart baslik="Toplam Personel" deger={personel.toplam} ikon="👥" />
          <StatKart baslik="Outsource" deger={personel.outsource} ikon="🏢" renk="#1a56db" />
          <StatKart baslik="Acik Kadro" deger={personel.acik_kadro} ikon="📋" renk="#F59E0B" />
          <StatKart baslik="Net Kar / Personel" deger={fmt(netKarPerPersonel) + ' TL'} ikon="💵" renk={netKarPerPersonel >= 0 ? '#059669' : '#DC2626'} alt="Net kar / outsource personel" />
        </div>

        {personel.musteri_dagilim?.length > 0 && (
          <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', overflow: 'hidden' }}>
            <div style={{ padding: '1rem 1.25rem', borderBottom: '1px solid #F3F4F6', fontSize: '14px', fontWeight: '600' }}>Musteri Bazli Personel Dagilimi</div>
            <div style={{ overflowX: 'auto' }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '13px' }}>
                <thead>
                  <tr style={{ background: '#F9FAFB' }}>
                    <th style={{ padding: '10px 16px', textAlign: 'left', fontWeight: '600', color: '#6B7280' }}>Musteri</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', fontWeight: '600', color: '#6B7280' }}>Personel</th>
                    <th style={{ padding: '10px 16px', textAlign: 'right', fontWeight: '600', color: '#6B7280' }}>Toplam Gelir</th>
                  </tr>
                </thead>
                <tbody>
                  {personel.musteri_dagilim.map((m, i) => (
                    <tr key={i} style={{ borderTop: '1px solid #F3F4F6' }}>
                      <td style={{ padding: '10px 16px', fontWeight: '500' }}>{m.firma_adi}</td>
                      <td style={{ padding: '10px 16px', textAlign: 'right' }}>
                        <span style={{ background: '#EEF2FF', color: '#4F46E5', padding: '2px 10px', borderRadius: '99px', fontWeight: '600' }}>{m.personel_sayisi}</span>
                      </td>
                      <td style={{ padding: '10px 16px', textAlign: 'right', color: '#059669', fontWeight: '600' }}>{fmt(m.toplam_gelir)} TL</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </Bolum>

      {/* İŞE ALIM */}
      <Bolum baslik="Ise Alim">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '1rem', marginBottom: '1.5rem' }}>
          <StatKart baslik="Toplam Aday" deger={isealim.toplam_aday} ikon="👤" />
          <StatKart baslik="Bu Ay Tamamlanan" deger={isealim.bu_ay_tamamlanan} ikon="✅" renk="#059669" />
          <StatKart baslik="Ort. Hiring Suresi" deger={isealim.ort_hiring_gun + ' gun'} ikon="📅" renk="#1a56db" />
          <StatKart baslik="Elenme Orani" deger={yuzde(isealim.elenme_orani)} ikon="❌" renk="#DC2626" />
        </div>

        {isealim.pipeline && (
          <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', padding: '1.25rem' }}>
            <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '1rem' }}>Aday Pipeline</div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(120px, 1fr))', gap: '8px' }}>
              {[
                { label: 'Yeni', deger: isealim.pipeline.yeni, renk: '#6B7280' },
                { label: 'Tel. Bekleme', deger: isealim.pipeline.telefon_bekleme, renk: '#F59E0B' },
                { label: 'Mus. Bekleme', deger: isealim.pipeline.musteri_bekleme, renk: '#1a56db' },
                { label: 'Teklif Bekleme', deger: isealim.pipeline.teklif_bekleme, renk: '#7C3AED' },
                { label: 'Teklif Sureci', deger: isealim.pipeline.teklif_sureci, renk: '#059669' },
                { label: 'Tamamlandi', deger: isealim.pipeline.tamamlandi, renk: '#059669' },
                { label: 'Elendi', deger: isealim.pipeline.elendi, renk: '#DC2626' },
              ].map((item, i) => (
                <div key={i} style={{ background: '#F9FAFB', borderRadius: '8px', padding: '12px', textAlign: 'center', borderTop: '3px solid ' + item.renk }}>
                  <div style={{ fontSize: '22px', fontWeight: '700', color: item.renk }}>{item.deger || 0}</div>
                  <div style={{ fontSize: '11px', color: '#6B7280', marginTop: '2px' }}>{item.label}</div>
                </div>
              ))}
            </div>
          </div>
        )}
      </Bolum>

      {/* TURNOVER */}
      <Bolum baslik="Turnover">
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: '1rem' }}>
          <StatKart baslik="Turnover Rate" deger={yuzde(turnover.rate)} ikon="🔄" renk={turnover.rate > 20 ? '#DC2626' : turnover.rate > 10 ? '#F59E0B' : '#059669'} alt={turnover.rate > 20 ? 'Yuksek - dikkat!' : turnover.rate > 10 ? 'Orta seviye' : 'Normal'} />
          <StatKart baslik="Ayrilan Personel" deger={turnover.ayrilan_sayi} ikon="🚪" renk="#DC2626" />
        </div>
      </Bolum>

      {/* RİSK & EĞİTİM & OPERASYONEL */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '1.5rem' }}>
        <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', padding: '1.25rem' }}>
          <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '1rem', color: '#DC2626' }}>Risk & Uyarilar</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 12px', background: risk.performanssiz_personel > 0 ? '#FEF2F2' : '#F0FDF4', borderRadius: '8px' }}>
              <span style={{ fontSize: '13px' }}>Performans kaydi girilmemis</span>
              <span style={{ fontWeight: '700', color: risk.performanssiz_personel > 0 ? '#DC2626' : '#059669' }}>{risk.performanssiz_personel}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 12px', background: risk.izin_birikimli > 0 ? '#FFFBEB' : '#F0FDF4', borderRadius: '8px' }}>
              <span style={{ fontSize: '13px' }}>Izin birikimli personel</span>
              <span style={{ fontWeight: '700', color: risk.izin_birikimli > 0 ? '#F59E0B' : '#059669' }}>{risk.izin_birikimli}</span>
            </div>
          </div>
        </div>

        <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', padding: '1.25rem' }}>
          <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '1rem' }}>Egitim & Gelisim</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div>
              <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '13px', marginBottom: '6px' }}>
                <span>Tamamlanma Orani</span>
                <span style={{ fontWeight: '600', color: '#059669' }}>{yuzde(egitim.tamamlanma_orani)}</span>
              </div>
              <ProgressBar deger={egitim.tamamlanma_orani} renk="#059669" />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '8px', marginTop: '4px' }}>
              <div style={{ textAlign: 'center', background: '#F9FAFB', borderRadius: '8px', padding: '10px' }}>
                <div style={{ fontSize: '18px', fontWeight: '700' }}>{egitim.toplam_atama}</div>
                <div style={{ fontSize: '11px', color: '#6B7280' }}>Toplam</div>
              </div>
              <div style={{ textAlign: 'center', background: '#F0FDF4', borderRadius: '8px', padding: '10px' }}>
                <div style={{ fontSize: '18px', fontWeight: '700', color: '#059669' }}>{egitim.tamamlanan}</div>
                <div style={{ fontSize: '11px', color: '#6B7280' }}>Tamamlanan</div>
              </div>
              <div style={{ textAlign: 'center', background: '#FEF2F2', borderRadius: '8px', padding: '10px' }}>
                <div style={{ fontSize: '18px', fontWeight: '700', color: '#DC2626' }}>{egitim.suresi_gecmis}</div>
                <div style={{ fontSize: '11px', color: '#6B7280' }}>Suresi Gecmis</div>
              </div>
            </div>
            <div style={{ fontSize: '13px', color: '#6B7280' }}>Bu ay {egitim.bu_ay_sertifika} sertifika yuklendi</div>
          </div>
        </div>

        <div style={{ background: '#fff', border: '1px solid #E5E7EB', borderRadius: '12px', padding: '1.25rem' }}>
          <div style={{ fontSize: '14px', fontWeight: '600', marginBottom: '1rem' }}>Operasyonel</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 12px', background: operasyonel.bekleyen_onay > 0 ? '#FFFBEB' : '#F0FDF4', borderRadius: '8px' }}>
              <span style={{ fontSize: '13px' }}>Bekleyen onay</span>
              <span style={{ fontWeight: '700', color: operasyonel.bekleyen_onay > 0 ? '#F59E0B' : '#059669' }}>{operasyonel.bekleyen_onay}</span>
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '10px 12px', background: operasyonel.bekleyen_talep > 0 ? '#FFFBEB' : '#F0FDF4', borderRadius: '8px' }}>
              <span style={{ fontSize: '13px' }}>Bekleyen talep</span>
              <span style={{ fontWeight: '700', color: operasyonel.bekleyen_talep > 0 ? '#F59E0B' : '#059669' }}>{operasyonel.bekleyen_talep}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YonetimDashboardPage;
